import { ARTICLE_PATHS } from "./articleUrls"

export const ADDITIONAL_REQUIREMENTS = {
  EXPERIENCE_CREDITS: {
    id: "experience_credits",
    title: "Experience Credits",
    explainer:
      "Experience credits are calculated based on your specific education and industry work, including your current job. Forecast your credits now so you can ensure you meet the requirements for PGA Membership by the end of the program.",
    completedDescription: "You have met the experience credit requirement.",
    linkText: "Learn More",
    linkUrl: ARTICLE_PATHS.EXPERIENCE_CREDITS,
  },

  EMPLOYMENT: {
    id: "employment",
    title: "Eligible Employment",
    description: "You must have eligible employment to apply for Membership.",
    completedDescription: "You have eligible employment.",
    primaryLinkText: "Update employment",
  },

  AGE: {
    id: "age",
    title: "Age Requirement",
    description:
      "You must be 18 or older to apply for Membership. Contact PGA Membership Services if your date of birth is incorrect.",
  },

  GOOD_STANDING: {
    id: "good_standing",
    title: "Dues",
    description:
      "You must pay outstanding dues before you apply for Membership.",
    completedDescription: "Your dues are current.",
    primaryLinkText: "Pay dues",
  },

  BACKGROUND_CHECK: {
    id: "background_check",
    title: "Background Check",
    description:
      "You must have a current approved background check to apply for Membership.",
    completedDescription: "Your background check was approved!",
    onFileDescription:
      "An approved background check must be on file.",
    onFileCompletedDescription: "Your background check is on file.",
    primaryLinkText: "Start Background Check",
    primaryLinkUrl: "/background-check",
  },

  ACCEPTABLE_PROGRESS: {
    id: "acceptable_progress",
    title: "Path to Membership Window",
    description:
      "Your Path to Membership window has ended. Reapply to the Associate Program to continue.",
    primaryLinkText: "Reapply",
  },

  PAT: {
    id: "playing_ability_test",
    title: "Playing Ability Test",
    description:
      "Congratulations, you have a qualifying score on your PAT. You will still need to pass the PAT in order to enroll as a PGA of America Member by the end of Level 3.",
    incompleteDescription:
      "You must pass the Playing Ability Test before applying for PGA of America Membership.",
    expiredDescription:
      "Your PAT score has expired. Register to try again when you are ready.",
    completedDescription: "You have passed the Playing Ability Test.",
    primaryLinkText: "Find a PAT",
    secondaryLinkText: "View Guide",
    secondaryLinkUrl: ARTICLE_PATHS.PLAYING_ABILITY_TEST,
  },
}
